import  { CONTRACT_GROUP_STATUS } from '../constants/contract'

export const hasPolicyInformation = ({ portal }) => {
  const groupStatus = portal.contract?.contractGroupStatus

  return groupStatus && groupStatus !== CONTRACT_GROUP_STATUS.VOID
}
